export enum TrackTypeConstants {
  DATAFEED = 'DATAFEED',
  MORNINGSTAR_REQUEST = 'MORNINGSTAR_REQUEST',
  PRIVATE_TRACK = 'PRIVATE_TRACK',
  PROXY = 'PROXY',
}
